module.exports = __webpack_public_path__ + "static/media/phone-icon.2e8e401f.svg";